import { WebFooter } from '@/components/web-footer'
import { WebTopHeader } from '@/components/web-top-header'

interface MainWebLayoutProps {
  title?: string
  showRight?: boolean
  children: React.ReactNode
}

export const MainWebLayout = (props: MainWebLayoutProps): JSX.Element => {
  const { showRight = true } = props

  return (
    <main className="flex min-h-screen flex-col bg-basic-bg">
      <WebTopHeader showRight={showRight} />

      <div className="flex grow flex-col">{props.children}</div>

      <WebFooter />
    </main>
  )
}

export function getMainWebLayout(
  page: React.ReactElement,
  options?: { showRight: boolean }
) {
  return <MainWebLayout {...options}>{page}</MainWebLayout>
}
